import React from 'react';
import { render } from 'react-dom';
import App from './App';
import firebase from './lib/firebase.prod';
import { FirebaseContext } from './context/firebase';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import CustomizedZendesk from './components/CustomizedZendesk/CustomizedZendesk';
import SimpleReactLightbox from 'simple-react-lightbox';

render(
	<>
		<FirebaseContext.Provider value={{ firebase }}>
			<Provider store={store}>
				<PersistGate loading={null} persistor={persistor}>
					<SimpleReactLightbox>
						<App />
					</SimpleReactLightbox>
				</PersistGate>
			</Provider>
		</FirebaseContext.Provider>
	</>,

	document.getElementById('root')
);
